import React from 'react';
import PropTypes from "prop-types";

import styles from './checkbox.scss';

function Checkbox(props) {

    const { checked, onChange, onClick, onBlur, children, checkboxClass, checkboxContainerClass, ...otherProps } = props;

    return (
        <div className={checkboxContainerClass}>
            <label className={styles.checkboxLabel}>
                <input 
                    {...otherProps}
                    type="checkbox" 
                    onChange={e => onChange(e.target.checked)}
                    onClick={onClick}
                    onBlur={onBlur}
                    className={checkboxClass}
                    checked={checked}
                />
                <span className={styles.customChecboxIcon}>
                    {children}
                </span>
            </label>
        </div>
    )
}

Checkbox.defaultProps = {
    onChange: () => {},
    onClick: e => e.stopPropagation(),
    checkboxClass: styles.checkbox,
    checkboxContainerClass: styles.checkboxContainer
}

Checkbox.propTypes = {
    checked: PropTypes.bool,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    checkboxClass: PropTypes.string,
    checkboxContainerClass: PropTypes.string
}

export default Checkbox
